// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + chunkId + "." + "9fe58914c8bbb1d76e48" + ".js";
};